import { Paragraph } from "@fronterahealth/frontera-ui-components";

export const FieldLayout = ({
  title,
  className,
  children,
}: {
  title: string;
  className?: string;
  children: React.ReactNode;
}) => (
  <div className={className ?? "flex-1 min-w-0"}>
    <Paragraph>{title}</Paragraph>
    <div className="mt-1">{children}</div>
  </div>
);
